import { ButtonBorderedKVBase, DefaultModal, Loading } from '@/presentation/components';
import { IconDangeCircle, IconInfo, IconSupport } from '@/presentation/components/icons';
import classNames from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router';
import { useRecoilState } from 'recoil';
import Styles from './choose-plan-styles.scss';
import { Header, Footer, TopButton, choosePlanState, Plan, List } from './components';
import { isMobile } from 'mobile-device-detect';
import { ENTERPRICE_PRICE_RANGES_DATA } from '@/presentation/constants/stripe-constants';
import { parseNumber, parseNumberMoney } from '@/presentation/utils/number-utils';
import useStripeConstants from '@/presentation/hooks/use-stripe-constants';
import usePartner from '@/presentation/hooks/use-partner';
const Login = () => {
    const [state, setState] = useRecoilState(choosePlanState);
    const navigate = useNavigate();
    const setPlanSelected = (index) => setState(prev => (Object.assign(Object.assign({}, prev), { planSelected: index })));
    const toggleModal = (flag) => setState(prev => (Object.assign(Object.assign({}, prev), { modalOpen: flag })));
    const { rootPath } = usePartner({});
    const { loading, freeTrialName, individualPlanName, enterprisePlanName, individualDefaultPrice, enterpriseDefaultPrice, individualSemiAnnualDeafultPrice, getPriceWithLookupKey } = useStripeConstants();
    if (loading) {
        return React.createElement(Loading, null);
    }
    return (React.createElement("div", { className: Styles.signUpWrap },
        React.createElement(Header, null),
        React.createElement("div", { style: { textAlign: 'center' } },
            React.createElement("h1", null, "Registration"),
            React.createElement("h3", null, "Please select a subscription plan to start your registration."),
            React.createElement("div", { className: Styles.topBtnWrap },
                React.createElement("div", { className: Styles.topBtnGroup },
                    React.createElement(TopButton, { type: "button", selected: state.planSelected === 0, onClick: () => setPlanSelected(0), dataTestId: "annual-btn" }, "Annual"),
                    React.createElement(TopButton, { dataTestId: "semi-annual-btn", type: "button", selected: state.planSelected === 1, onClick: () => setPlanSelected(1) }, "Semi-Annual"))),
            state.planSelected === 0 ? (React.createElement("div", { className: Styles.planWrap, "data-testid": "annual-wrap" },
                React.createElement("div", { className: Styles.plan },
                    React.createElement(Plan, { onClickButton: () => navigate(`${rootPath}signup?plan=annual-free-trial`), title1: freeTrialName, title2: "", price: "Try for Free", subtitle: "No Credit Card Required", detail: "Up to 49 Students", colorDetail: "#695CFF", detailText: "Includes a 7-day free trial with access to one lesson", planName: "annual-free-trial", buttonText: "Try It Now" })),
                React.createElement("div", { className: Styles.plan },
                    React.createElement(Plan, { onClickButton: () => navigate(`${rootPath}signup?plan=annual-individual`), title1: individualPlanName, title2: "", price: parseNumberMoney(individualDefaultPrice), subtitle: "Per Student, Per Year", detail: "Up to 49 Students", colorDetail: "#695CFF", detailText: "Best for individuals, parents, and small groups with fewer than 50 students.", planName: "annual-individual", buttonText: "Enroll" })),
                React.createElement("div", { className: Styles.plan },
                    React.createElement(Plan, { onClickButton: () => navigate(`${rootPath}signup?plan=annual-enterprise`), title1: enterprisePlanName, title2: "", price: parseNumberMoney(enterpriseDefaultPrice), subtitle: "Per Student, Per Year", detail: "50+ Students Only", colorDetail: "#F48218", detailText: "Enroll More, Save More! Perfect for schools, districts, organizations, and large student groups.", planName: "annual-enterprise", buttonText: "Enroll" })))) : (React.createElement("div", { className: Styles.planWrap, "data-testid": "semi-annual-wrap" },
                React.createElement("div", { className: Styles.plan },
                    React.createElement(Plan, { onClickButton: () => navigate(`${rootPath}signup?plan=semi-annual-free-trial`), title1: freeTrialName, title2: "", price: "Try for Free", subtitle: "No Credit Card Required", detail: "Up to 49 Students", colorDetail: "#695CFF", detailText: "Includes a 7-day free trial with access to one lesson", planName: "semi-annual-free-trial", buttonText: "Try It Now" })),
                React.createElement("div", { className: Styles.plan },
                    React.createElement(Plan, { onClickButton: () => navigate(`${rootPath}signup?plan=semi-annual-individual`), title1: individualPlanName, title2: "", price: parseNumberMoney(individualSemiAnnualDeafultPrice), subtitle: "Per Student, Per 6 Months", detail: "Up to 49 Students", colorDetail: "#695CFF", detailText: "Best for individuals, parents, and small groups with fewer than 50 students.", planName: "semi-annual-individual", buttonText: "Enroll" })),
                React.createElement("div", { className: classNames(Styles.plan, Styles.planDisabled) },
                    React.createElement(Plan, { disabled: true, title1: enterprisePlanName, title2: "", price: parseNumberMoney(enterpriseDefaultPrice), subtitle: "Per Student, Per Year", detail: "50+ Students Only", colorDetail: "#F48218", detailText: "Enroll More, Save More! Perfect for schools, districts, organizations, and large student groups.", planName: "semi-annual-enterprise", buttonText: "Enroll" })))),
            React.createElement("div", { className: Styles.infoText },
                React.createElement("div", { className: Styles.infoTextWrap },
                    React.createElement("div", { style: { padding: '0.25rem' } },
                        React.createElement(IconInfo, null)),
                    React.createElement("div", { className: Styles.contactText },
                        "If you need to change your plan later, we have you covered. Feel free to",
                        ' ',
                        React.createElement("span", { onClick: () => toggleModal(true) }, "contact us"),
                        " for any additional information."))),
            React.createElement("br", null),
            state.planSelected === 0 ? (React.createElement("div", null,
                React.createElement(List, { title: `${individualPlanName} Annual Pricing`, items: [
                        {
                            title: React.createElement("div", null, freeTrialName),
                            subtitle: 'Access to only 1 lesson',
                            price: 'Free',
                            detail: 'Cancel any time',
                            backgroundColor: 'rgba(101, 199, 2, 0.1)'
                        },
                        {
                            title: getLineText('Elementary', '3rd-5th'),
                            subtitle: '1-49 students',
                            price: getPriceWithLookupKey('ANNUAL_ELEMENTARY_3-5'),
                            detail: 'Per Student, Per Year'
                        },
                        {
                            title: getLineText('Middle School', '6th-8th'),
                            subtitle: '1-49 students',
                            price: getPriceWithLookupKey('ANNUAL_MIDDLE_SCHOOL_6-8'),
                            detail: 'Per Student, Per Year',
                            backgroundColor: '#F2F4F8'
                        },
                        {
                            title: getLineText('High School', '9th-12th'),
                            subtitle: '1-49 students',
                            price: getPriceWithLookupKey('ANNUAL_HIGH_SCHOOL_9-12'),
                            detail: 'Per Student, Per Year'
                        }
                    ] }),
                React.createElement(List, { title: `${enterprisePlanName} Annual Pricing`, items: ENTERPRICE_PRICE_RANGES_DATA.map((item, index) => ({
                        title: (React.createElement("div", null, item.max === Infinity
                            ? `${parseNumber(item.min)}+`
                            : `${parseNumber(item.min)}-${parseNumber(item.max)}`)),
                        subtitle: 'Students',
                        price: getPriceWithLookupKey(item.lookup_key),
                        detail: 'Per Student, Per Year',
                        backgroundColor: index % 2 === 0 ? '#F2F4F8' : undefined
                    })) }))) : (React.createElement(List, { title: `${individualPlanName} Semi-Annual Pricing`, items: [
                    {
                        title: React.createElement("div", null, freeTrialName),
                        subtitle: 'Access to only 1 lesson',
                        price: 'Free',
                        detail: 'Cancel any time',
                        backgroundColor: 'rgba(101, 199, 2, 0.1)'
                    },
                    {
                        title: getLineText('Elementary', '3rd-5th'),
                        subtitle: '1-49 students',
                        price: getPriceWithLookupKey('SEMI_ANNUAL_ELEMENTARY_3-5'),
                        detail: 'Per Student, Per Year'
                    },
                    {
                        title: getLineText('Middle School', '6th-8th'),
                        subtitle: '1-49 students',
                        price: getPriceWithLookupKey('SEMI_ANNUAL_MIDDLE_SCHOOL_6-8'),
                        detail: 'Per Student, Per Year',
                        backgroundColor: '#F2F4F8'
                    },
                    {
                        title: getLineText('High School', '9th-12th'),
                        subtitle: '1-49 students',
                        price: getPriceWithLookupKey('SEMI_ANNUAL_HIGH_SCHOOL_9-12'),
                        detail: 'Per Student, Per Year'
                    }
                ] })),
            state.planSelected === 1 && (React.createElement("div", { className: Styles.warningDiv },
                React.createElement("div", { className: Styles.warningTextWrap },
                    React.createElement("div", { style: { padding: '0.5rem' } },
                        React.createElement(IconDangeCircle, null)),
                    React.createElement("div", { className: Styles.warningText },
                        "The ",
                        enterprisePlanName,
                        " plan is not available for a semi-annual subscription."))))),
        React.createElement(Footer, null),
        React.createElement(DefaultModal, { width: isMobile ? '90' : '55', wUnit: "%", open: state.modalOpen, onClose: () => toggleModal(false), showClose: true },
            React.createElement("div", { className: Styles.modalWrap },
                React.createElement("div", { className: Styles.mainPartAE },
                    React.createElement("div", null,
                        React.createElement(IconSupport, null)),
                    React.createElement("h1", { className: Styles.titleSupport }, "Contact us for support"),
                    React.createElement("div", { style: { padding: '1rem' } },
                        React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => window.open('https://www.kidvestors.co/contactus', '_blank') }, "Contact Us")))))));
};
const getLineText = (title1, title2) => {
    if (isMobile) {
        return (React.createElement("div", { className: Styles.divWrap1 },
            title1,
            " ",
            React.createElement("div", { className: Styles.txtGray },
                "(",
                title2,
                ")")));
    }
    return (React.createElement("div", { className: Styles.divWrap1 },
        title1,
        " ",
        React.createElement("span", { className: Styles.txtGray },
            "(",
            title2,
            ")")));
};
export default Login;
